import React from 'react'
import './style.sass'

const LinkButton = ({ btnText, imgIcon, additionalStyle, onClick = () => {} }) => {
  return (
    <label className="link-button-container" onClick={onClick} style={additionalStyle}>
      {!imgIcon || <img src={imgIcon} alt='icon' />} {btnText}
    </label>
  )
}

export default LinkButton
